export const TILE_CONNECT_PLATFORMS = ["facebook", "instagram", "youtube", "tiktok"] as const;

export type TileConnectPlatform = (typeof TILE_CONNECT_PLATFORMS)[number];
// instagram_direct is Instagram Login, a different authorization from the Facebook-linked "instagram" flow, so it has its own return route
export type ReportConnectPlatform = "gbp" | "instagram_direct" | TileConnectPlatform;

const REPORT_CONNECT_PLATFORMS: readonly string[] = ["gbp", "instagram_direct", ...TILE_CONNECT_PLATFORMS];

export const isTileConnectPlatform = (value: string): value is TileConnectPlatform =>
  (TILE_CONNECT_PLATFORMS as readonly string[]).includes(value);

export const isReportConnectPlatform = (value: unknown): value is ReportConnectPlatform =>
  typeof value === "string" && REPORT_CONNECT_PLATFORMS.includes(value);

// The backend only accepts [a-zA-Z0-9/_-] here, so ids go in the path and the query string is left to the callback
export const buildConnectReturnPath = (
  platform: ReportConnectPlatform,
  reportId: string,
  businessId: string,
  accountId?: string,
): string =>
  `report-builder/connect/${platform}/${reportId}/${businessId}${accountId && /^[a-zA-Z0-9_-]+$/.test(accountId) ? `/${accountId}` : ""}`;
